import FilmQuizCheckCorrectAnswerSvg from 'src/components/svg/FilmQuizCheckCorrectAnswerSvg';
import { type MovieQuestion } from 'src/lib/movieinfo/movieinfotypes';
import styled, { css } from 'src/lib/styles/css';

//#region [Props]
type ShowAnswerProps = {
	isCorrectAnswer: boolean;
	question: MovieQuestion;
};
//#endregion

//#region [Component]
export default function ShowAnswer({ isCorrectAnswer, question }: ShowAnswerProps) {
	let correctAnswer = question!.answerAlternatives!.find(t => t!.isCorrect)!.answerAlternative;
	return <SShowAnswer>
		<SAnswer $isCorrect={isCorrectAnswer}>
			{isCorrectAnswer ? <>
				<FilmQuizCheckCorrectAnswerSvg /> Riktig svar!
			</> :
				"Feil, svaret var " + correctAnswer
			}
		</SAnswer>
	</SShowAnswer>;
}
//#endregion

//#region [Styles]
const SShowAnswer = styled.div`
	padding-left: 10px;
	padding-right: 10px;
	padding-bottom: 5px;
`;

type SAnswerProps = {
	$isCorrect: boolean;
}

const SAnswer = styled.div<SAnswerProps>`
	max-width: 400px;
	margin-left: auto;
	margin-right: auto;
	border-radius: 10px;
	padding: 10px;
	font-weight: bold;

	${props => props.$isCorrect ? css`
		background-color: #36de71;
		color: var(--palette-lilla-hovedfarge);
		margin-bottom: 20px;

		display: flex;
		align-items: center;
		justify-content: center;

		svg {
			margin-right: 10px;
		}
	`: css`
		background-color: #d63333;
		margin-bottom: 20px;
	`}

`;

//#endregion